import { Injectable } from '@angular/core';

@Injectable()
export class EnvironmentNameService {

    public getEnvironment(hostname: string, instanceUrl: string): string {
        const environment: string = (hostname + instanceUrl)
            .split(/[.\/]/g)
            .filter((str: string) => str
                && str !== 'afidium-solutions'
                && str !== 'solutions'
                && str !== 'wenji'
                && str !== 'com'
                && str !== 'fr')
            .join(' ');

        return environment;
    }
}
